import * as yup from 'yup';
// import ITInquery from '../../interfaces/inquiry/inquiry';

export const customerOpinionsInitialValues = {
	email: '',
	messageType: '',
	comments: '',
};

export const customerOpinionsSchema = yup.object().shape({
	email: yup.string().email('emailNotValid'),
	messageType: yup.string().required('required'),
	comments: yup.string().required('required'),
	// captchaValid: yup.boolean().test('is-valid-captcha', 'captcha-valid', value => value),
});
